import { Switch } from "@mui/material";
import React from "react";

const ToggleSwitch = (props) => {
  return (
    <>
  <label className="switch me-2">
        <Switch
          checked={props.value}
          onChange={props.onChange}
          inputProps={{ 'aria-label': 'controlled' }}
          onClick={props.onClick}
          style={{ cursor: "pointer" }}
          disabled={props.disabled}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#1c2b20',    // thumb color when checked
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: '#1c2b20',  // track color when checked
            },
          }}
        />
      </label>
    </>
  );
};

export default ToggleSwitch;
